import {
  CompareDataset,
  DatasetRef,
  datasetToCompareItem,
  isSameDatasetRef,
  toReleaseRef,
  useCompare,
} from 'components/shared/Compare';
import useDataset from 'hooks/data/datasets/useDataset';

// Full ref, not id: an id-only match would pick up a staged dataset from another release.
export const useResolveCompareDataset = (ref?: DatasetRef): { dataset?: CompareDataset; isLoading: boolean } => {
  const { datasets } = useCompare();

  const contextItem = ref ? datasets.find((dataset) => isSameDatasetRef(dataset, ref)) : undefined;
  const shouldFetch = Boolean(ref) && !contextItem;
  const release = ref ? toReleaseRef(ref) : undefined;

  const { data: fetched, isLoading } = useDataset(shouldFetch ? ref?.id : undefined, false, release);

  const dataset =
    contextItem ??
    // The requested release, never the route's: in another release this id is a different dataset.
    (ref && fetched ? datasetToCompareItem(ref.id, fetched, { ver: ref.version, system_model: ref.systemModel }) : undefined);

  return { dataset, isLoading: shouldFetch && isLoading };
};
